// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3JiZy","gfeWrapper":"CalendarEvent_gfeWrapper__mXDXn"};